import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import Chip from '@mui/material/Chip';
import { Translate, openFile, byteSize, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tour-category.reducer';

const FieldLabel = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
    {children}
  </Typography>
);

const FieldValue = ({ children, sx }: { children: React.ReactNode; sx?: object }) => (
  <Typography variant="body1" sx={{ mb: 2, ...sx }}>
    {children || '-'}
  </Typography>
);

const BooleanDisplay = ({ value }: { value?: boolean }) =>
  value ? (
    <Chip icon={<FontAwesomeIcon icon="check" />} label="Yes" color="success" size="small" />
  ) : (
    <Chip icon={<FontAwesomeIcon icon="times" />} label="No" color="error" size="small" />
  );

export const TourCategoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tourCategoryEntity = useAppSelector(state => state.tourCategory.entity);
  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 4, p: 2 }}>
      <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <h2 data-cy="tourCategoryDetailsHeading">
          <Translate contentKey="jhipsterSampleApplicationApp.tourCategory.detail.title">TourCategory</Translate>
        </h2>
        {tourCategoryEntity.id && (
          <Box sx={{ bgcolor: 'primary.light', color: 'primary.contrastText', px: 2, py: 0.5, borderRadius: 1, fontWeight: 'bold' }}>
            ID: {tourCategoryEntity.id}
          </Box>
        )}
      </Box>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourCategory.code" />
          </FieldLabel>
          <FieldValue>{tourCategoryEntity.code}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourCategory.enabled" />
          </FieldLabel>
          <BooleanDisplay value={tourCategoryEntity.enabled} />

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourCategory.icon" />
          </FieldLabel>
          <FieldValue>{tourCategoryEntity.icon}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourCategory.createdDate" />
          </FieldLabel>
          <FieldValue>
            {tourCategoryEntity.createdDate ? (
              <TextFormat value={tourCategoryEntity.createdDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourCategory.defaultImage" />
          </FieldLabel>
          <FieldValue>{tourCategoryEntity.defaultImage}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourCategory.defaultImageData" />
          </FieldLabel>
          {tourCategoryEntity.defaultImageData ? (
            <Box sx={{ mb: 2 }}>
              {tourCategoryEntity.defaultImageDataContentType ? (
                <a onClick={openFile(tourCategoryEntity.defaultImageDataContentType, tourCategoryEntity.defaultImageData)}>
                  <img
                    src={`data:${tourCategoryEntity.defaultImageDataContentType};base64,${tourCategoryEntity.defaultImageData}`}
                    style={{ maxHeight: '30px' }}
                  />
                </a>
              ) : null}
              <Typography variant="body2" color="text.secondary">
                {tourCategoryEntity.defaultImageDataContentType}, {byteSize(tourCategoryEntity.defaultImageData)}
              </Typography>
            </Box>
          ) : (
            <FieldValue>No image</FieldValue>
          )}
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourCategory.createdBy" />
          </FieldLabel>
          <FieldValue>{tourCategoryEntity.createdBy ? tourCategoryEntity.createdBy.login : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourCategory.parent" />
          </FieldLabel>
          <FieldValue>{tourCategoryEntity.parent ? tourCategoryEntity.parent.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourCategory.tour" />
          </FieldLabel>
          <FieldValue>
            {tourCategoryEntity.tours
              ? tourCategoryEntity.tours.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.code}</a>
                    {tourCategoryEntity.tours && i === tourCategoryEntity.tours.length - 1 ? '' : ', '}
                  </span>
                ))
              : null}
          </FieldValue>
        </Grid>

        <Grid size={12}>
          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button
              component={Link}
              to="/tour-category"
              replace
              color="info"
              variant="outlined"
              startIcon={<FontAwesomeIcon icon="arrow-left" />}
            >
              <Translate contentKey="entity.action.back">Back</Translate>
            </Button>
            <Button
              component={Link}
              to={`/tour-category/${tourCategoryEntity.id}/edit`}
              replace
              color="primary"
              variant="contained"
              startIcon={<FontAwesomeIcon icon="pencil-alt" />}
            >
              <Translate contentKey="entity.action.edit">Edit</Translate>
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TourCategoryDetail;
